<template>
  <div class='animated fadeIn'>
    <b-row>
      <b-col md='6'>
        <b-card>
          <div slot='header'>
            <strong><i class="fa fa-align-justify"></i> Créer un nouveau rapport</strong>
          </div>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle"><strong>Libellé : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelle" v-model="libelle" :class="{hasError: errors.libelle !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.libelle }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="libelle_technique"><strong>Libellé technique : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="libelle_technique" v-model="libelle_technique" :class="{hasError: errors.libelle_technique !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.libelle_technique }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="description"><strong>Description : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-textarea id="description" v-model="description" :class="{hasError: errors.description !== ''}"></b-form-textarea>
              <span class='field-error'>{{ errors.description }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="destinataire_obligatoire"><strong>Destinataire obligatoire : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="destinataire_obligatoire" v-model="destinataire_obligatoire" :class="{hasError: errors.destinataire_obligatoire !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.destinataire_obligatoire }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="destinataires"><strong>Destinataires : </strong></label>
            </b-col>
            <b-col sm="9">
                <b-form-input type="text" id="destinataires" v-model="destinataires" placeholder="Adresses mail séparés par des ';'" :class="{hasError: errors.destinataires !== ''}"></b-form-input>
                <span class='field-error'>{{ errors.destinataires }}</span>
            </b-col>
          </b-row>
          <b-row class="mb-1">
            <b-col sm="3">
              <label for="is_system"><strong>Système : </strong></label>
            </b-col>
            <b-col sm="9">
              <b-form-group label-for="is_system">
                <b-form-radio v-model="is_system" name="is_system" value="1">Oui</b-form-radio>
                <b-form-radio v-model="is_system" name="is_system" value="0">Non</b-form-radio>
              </b-form-group>
            </b-col>
          </b-row>
          <div slot="footer">
            <b-button type="button" @click="returnBack" size="md" variant="secondary">
              <i class="fa fa-arrow-left"></i> Liste des rapports
            </b-button>
            <b-button type="button" @click="add" size="md" class="pull-right" variant="primary">
              <i class="fa fa-save"></i> Enregistrer
            </b-button>
          </div>
        </b-card>
      </b-col>
    </b-row>
  </div>

</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";

  export default {
    name: "Create",
    data() {
      return {
        libelle: '',
        libelle_technique: '',
        description: '',
        destinataire_obligatoire: '',
        destinataires: '',
        is_system: '1',
        errors: {
          libelle: '',
          libelle_technique: '',
          description: '',
          destinataire_obligatoire: '',
          destinataires: '',
        },
      }
    },
    created() {
      this.$axios.defaults.baseURL = getBaseUrl();
      this.$axios.defaults.headers.common['Authorization'] = getIdToken() + ' ' + getAccessToken();
      this.$axios.defaults.headers.common['Accept'] = 'application/json';
      this.$axios.defaults.headers.common['Provider'] = getProvider();
    },
    methods: {
      add() {
        if (this.validateData()) {
          this.$store.commit('IS_LOADING', true);
          let self = this;
          let dataPost = {};
          dataPost.libelle = this.libelle;
          dataPost.libelle_technique = this.libelle_technique;
          dataPost.description = this.description;
          dataPost.destinataire_obligatoire = this.destinataire_obligatoire;
          dataPost.destinataires = this.destinataires;
          dataPost.is_system = this.is_system

          this.$axios
            .post("/administration/rapports", dataPost)
            .then(() => {
              this.$store.commit('IS_LOADING', false);
              this.$swal({
                position: 'top',
                type: 'success',
                title: 'Création avec succès',
                text: 'Le rapport ' + dataPost.libelle + ' a bien été créé',
                showConfirmButton: false,
                timer: 5000
              });
              this.clearFields();
              this.returnBack()
            })
            .catch(() => {
              self.$store.commit('IS_LOADING', false);
              self.$swal({
                position: 'top',
                type: 'error',
                title: 'Attention !!',
                text: 'Un erreur est survenue, si le problème persiste merci de faire un ticket au support DOSI',
                showConfirmButton: false,
                timer: 5000
              });
            });
        }
      },
      returnBack() {
        this.$router.push({path: '/administration/rapports'});
      },
      validateData() {
        this.clearErrors();
        let valid = true;
        if (this.libelle.trim() === '') {
          this.errors.libelle = 'Le libellé est obligatoire';
          valid = false;
        }
        if (this.libelle_technique.trim() === '') {
          this.errors.libelle_technique = 'Le libellé technique est obligatoire';
          valid = false;
        }
        if (this.description.trim() === '') {
          this.errors.description = 'La description est obligatoire';
          valid = false;
        }
        if (this.destinataire_obligatoire.trim() === '') {
          this.errors.destinataire_obligatoire = 'Ce champ est obligatoire';
          valid = false;
        }
        if (this.destinataires.trim() === '') {
          this.errors.destinataires = 'Le champ destinaires est obligatoire';
          valid = false;
        }
        return valid;
      },
      clearErrors() {
        this.errors.libelle = '';
        this.errors.libelle_technique = '';
        this.errors.description = '';
        this.errors.destinataire_obligatoire = '';
        this.errors.destinataires = '';
      },
      clearFields() {
        this.libelle = '';
        this.libelle_technique = '';
        this.description = '';
        this.destinataire_obligatoire = '';
        this.destinataires = '';
      },
    }
  }
</script>
